import { Badge, Table } from "@chakra-ui/react";
import { useSchoolsContext } from "../../../../Contexts/schoolContext";
import { Session } from "../../../../services/Dtos";
import { formatDate } from "../../../../services/Utils";
import SettingsCard from "../../../CustomUi/SettingsCard";

interface Props {
  session: Session;
  handleClick: () => void;
}

export default function SessionCard({ session, handleClick }: Props) {
  const { school, accentColor } = useSchoolsContext();

  return (
    <SettingsCard minW={"270px"} handleClick={handleClick}>
      {school?.currentSessionId === session.id && (
        <Badge
          fontSize={"xs"}
          top={0}
          left={0}
          position={"absolute"}
          colorPalette="green"
        >
          Current
        </Badge>
      )}
      <Table.Root fontSize={"sm"} variant={"outline"}>
        <Table.Body>
          <Table.Row>
            <Table.Cell>Session</Table.Cell>
            <Table.Cell textAlign={"right"} fontWeight={"bold"} pl={5}>
              <Badge variant={"outline"} colorPalette={accentColor} size={"md"}>
                {session.sessionName}
              </Badge>
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Session Start Date</Table.Cell>
            <Table.Cell textAlign={"right"} fontWeight={"bold"} pl={5}>
              {formatDate(session.sessionStartDate)}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Session End Date</Table.Cell>
            <Table.Cell textAlign={"right"} fontWeight={"bold"} pl={5}>
              {formatDate(session.sessionEndDate)}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Order</Table.Cell>
            <Table.Cell textAlign={"right"} fontWeight={"bold"} pl={5}>
              {session.order}
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table.Root>
    </SettingsCard>
  );
}
